import { useEffect } from "react";

const SCRIPT_ID = "vercel-insights";
const SCRIPT_SRC = "/_vercel/insights/script.js";

declare global {
  interface Window {
    va?: (...args: unknown[]) => void;
    vaq?: unknown[];
  }
}

const setupVercelQueue = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (!window.va) {
    window.va = (...args: unknown[]) => {
      (window.vaq = window.vaq || []).push(args);
    };
  }
};

const ensureScript = () => {
  if (typeof document === "undefined" || !import.meta.env.PROD) {
    return;
  }

  const existingScript = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
  if (existingScript) {
    return existingScript;
  }

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.defer = true;
  script.src = SCRIPT_SRC;
  document.head.appendChild(script);

  return script;
};

const VercelAnalytics = () => {
  useEffect(() => {
    setupVercelQueue();
    ensureScript();
  }, []);

  return null;
};

export default VercelAnalytics;